import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Orion/WaterMark";
import NoTableData from "./NoTableData";
import NoData from './NoData';
import { useNavigate } from "react-router-dom";
import './CriticalCustom_Orion_fleet.css';
import DataTable from 'react-data-table-component';

export default function CriticalPackWiseTable_Orion({ gloablfilter }) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [criticalTableData, setCriticalTableData] = useState([]);
  const [TBSelected, setTBSelected] = useState('A');

  // const navigate = useNavigate();
  // const handleRowClick = (vehicleId) => {
  //   navigate(`/dashboard_bus/rca_bus/${vehicleId}`);
  // };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/highest_Temp_vehicles", body: { filterdata: gloablfilter, packType: TBSelected } }, critical_response)
  }, [gloablfilter, TBSelected])

  const critical_response = (data) => {
    setCriticalTableData(data);
  }

  const changeTB = (selectOp) => {
    setCriticalTableData([]);
    setTBSelected(selectOp);
    // fetchData({ url: API_URL_MAIN + "critical_vehicles_bus/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, packType: selectOp + extraThings["withDropdown"] } }, critical_response)
  }

  const columns = [
    // {name: 'Vin',selector: (row) => row.key.vehicleId,width: '30%',center: true, sortable: true},
    {
      name: 'Vin',
      // selector: (row) => row.key.vehicleId,width: '30%',
      selector: (row) => (
        <div>
         {/* <div onClick={() => handleRowClick(row.key.vehicleId)} style={{ cursor: 'pointer' }}> */}
          {row.key.vehicleId}
        </div>
      ),
      width: '24%',
      center: true,
    },
    { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '', center: true, sortable: true },
    { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '', center: true, sortable: true },
    { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '', center: true, sortable: true },
    { name: 'Temp(°C)', selector: (row) => row[TBSelected + '_Max_Cell_Temp'].value.toFixed(2), width: '', center: true, sortable: true },
    { name: 'Date', selector: (row) => row.key.eventdate, width: '', center: true, sortable: true }
  ];

  const customStyles = {

    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '11px',
      },
    },
    rows: {
      style: {
        fontSize: '11px', // Custom font size for data rows
        // height: '25px',
        minHeight: '35px',
      },
    },
    headRow: {
      style: {
        minHeight: '40px',
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => {
        return row.index % 2 === 0;
      },
      style: {
        backgroundColor: '#fff',
      },
    },
  ];


  return (
    <>
      {/* <div className="col-lg-12 col-md-6 col-sm-12 mt-3 pr-0"> */}
      <div className="chargingChartboxNew_Bus">
        <div className="v-title chargingTitleChart_Bus_fleet">
          <div className="row p-2">
            <div className="col-lg-9 col-md-7 col-sm-7 col-7">
              <b>20 Highest temp (°C) vehicles</b>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-5 col-5">
              <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTB(event.target.value)} value={TBSelected}>
                <option value="A">Pack A</option>
                <option value="B">Pack B</option>
                <option value="C">Pack C</option>
                <option value="D">Pack D</option>
              </select>
            </div>
          </div>
        </div>
        {/* <div className="tableContent_Bus px-2" style={{ overflowY: 'scroll', height: '248px' }}> */}
        <div className="tableContent_Bus px-2" style={{ height: '248px', position:"sticky" }}>
          <WaterMark />
          {
            (isLoading) ? <ChartLoader /> : (criticalTableData.length > 0) ?
            <DataTable
              columns={columns}
              data={criticalTableData.map((item, index) => ({
                ...item,
                index, // Add index here
                className: index % 2 === 0 ? 'even-row' : 'odd-row',
              }))}
              customStyles={customStyles}
              conditionalRowStyles={conditionalRowStyles}
              fixedHeader={true}
              fixedHeaderScrollHeight="248px"
            /> : 
            <NoData />
          }
        </div>
      </div>
      {/* </div> */}
    </>
  )
}
